import type { FC } from "react";
import { normalizeOrderCode } from "../../../../libs/mypage/orderCode";
import { formatAddressLines, type OrderDetailDTO } from "../../components/format";
import { SectionHeading, SectionHeadingLink } from "../../components/SectionHeading";

export const ShippingSection: FC<{ order: OrderDetailDTO }> = ({ order }) => {
  if (!order.shippingAddress) return null;
  const addr = order.shippingAddress;
  const slug = normalizeOrderCode(order.code);
  return (
    <section className="mb-10">
      <SectionHeading
        title="お届け先"
        meta={
          order.isAddressEditable ? (
            <SectionHeadingLink to={`/orders/${slug}/address`}>変更する</SectionHeadingLink>
          ) : undefined
        }
      />
      {order.hasAddressDeficiency && (
        <p className="pt-2 text-amber-700 text-xs leading-relaxed">
          ※ ご住所を確認できていません（郵便番号との不一致、 または番地の不足の可能性）。
          発送のため、 お届け先のご住所をご確認ください。
        </p>
      )}
      <div className="space-y-1 py-4 text-neutral-700 text-sm leading-relaxed">
        {addr.recipientName && (
          <p className="font-medium text-neutral-900">{addr.recipientName} 様</p>
        )}
        {formatAddressLines(addr).map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>
    </section>
  );
};
